import React from "react";
import { drawingFor } from "./drawings";
import { geometryFor, ONE_SHOT_STATES } from "./geometry";
import PenRoot from "./motion";
export default function PenLoader({ size = 20, state = "loading", value = 0, className, style, ...rest }) {
    const isOneShot = ONE_SHOT_STATES.has(state);
    const progressProps = state === "progress" ? {
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": Math.round(value)
    } : {};
    return /*#__PURE__*/ React.createElement(PenRoot, {
        role: isOneShot ? undefined : "progressbar",
        "aria-hidden": isOneShot || undefined,
        className: className ? `pen-${state} ${className}` : `pen-${state}`,
        style: {
            width: size,
            height: size,
            ...style
        },
        ...progressProps,
        ...rest
    }, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
    }, drawingFor(state, geometryFor(size), {
        value
    })));
}
